/**
 * cn — стандартный shadcn-хелпер: clsx (условные классы) + tailwind-merge
 * (разрешение конфликтов утилит). Использовать во всех компонентах,
 * мигрированных на Tailwind.
 */
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs) => twMerge(clsx(inputs));

export default cn;
